import { useState } from 'react';
import type { AccountUserLicenseTypeInput } from '@frameio/graphql-client/generated';
import { noop } from '@frameio/vapor';

export const useLicenseSelect = ({
  enabled = false,
}: {
  enabled?: boolean;
}) => {
  const [selectedLicenseType, setLicenseType] =
    useState<AccountUserLicenseTypeInput>('MEMBER');

  const licenseType = enabled ? selectedLicenseType : 'MEMBER';
  const onChangeLicenseType = enabled ? setLicenseType : noop;

  return {
    licenseType,
    onChangeLicenseType,
  };
};
